import './ClientProfile.scss';
import { useTranslation } from 'react-i18next';
import { useTaxAdvisor } from '../tax-advisor-context';
import classNames from 'classnames';
import CountryLabel from '../../../components/CountryLabel/CountryLabel';
import { Cell } from '../../Seller/SellerVATIds/SellerVATIds';
import { format } from 'date-fns';

export default function ClientProfile() {
  const { t } = useTranslation();
  const { company } = useTaxAdvisor();

  return (
    <div className='Page flex-grow-1'>
      <div className='container'>
        <div className='Paper p-4 Paper--sm mx-auto'>
          <div className='Text--30 fw-900 mb-4'>{company?.name}</div>
          <div className='row mb-3'>
            <div className='col-4 fw-600'>{t('Registration')}</div>
            <div className='col'>Berlin, Strasse 22, 44139</div>
          </div>
          <div className='row mb-3'>
            <div className='col-4 fw-600'>{t('Contact person')}</div>
            <div className='col'>John Doe</div>
          </div>
          <div className='row pb-1'>
            <div className='col-4 fw-600'>{t('Contact email')}</div>
            <div className='col'>
              <a
                className='Link--blue text-decoration-none'
                href={`mailto:testemail.test@gmail.com`}
                data-testid='client-email'
              >
                testemail.test@gmail.com
              </a>
            </div>
          </div>
          <div className='ClientProfile__separator mx-n4 my-4' />
          <div className='Text--20 fw-800 mb-2'>{t('VAT IDs')}</div>
          <div className='pb-1'>
            <div className='row'>
              <div className='col Text--gray'>{t('Country')}</div>
              <div className='col Text--gray'>{t('VAT ID')}</div>
              <div className='col Text--gray'>{t('Tax ID')}</div>
            </div>
            {DATA.map((item, i) => (
              <div
                className={classNames('row pb-3 pt-2 mx-0', {
                  'border-top': i > 0,
                })}
                key={i}
              >
                <div className='col ps-0'>
                  <CountryLabel country={item.Country.short_name} />
                </div>
                <div className='col'>
                  <Cell
                    number={item.vat_number}
                    date={item.start_date_vat_number}
                    status={item.vat_number_status}
                    delimeter='•'
                  />
                </div>
                <div className='col pe-0'>
                  <Cell
                    number={item.tax_number}
                    date={item.start_date_tax_number}
                    status={item.tax_number_status}
                    delimeter='•'
                  />
                </div>
              </div>
            ))}
          </div>
          <div className='ClientProfile__separator mx-n4 my-4' />
          <div className='Text--20 fw-800 mb-2'>{t('OSS Details')}</div>
          <div className='row mb-3'>
            <div className='col-4 fw-600'>{t('Country')}</div>
            <div className='col'>{t('DE')}</div>
          </div>
          <div className='row mb-3'>
            <div className='col-4 fw-600'>{t('VAT ID')}</div>
            <div className='col'>DE0000000000</div>
          </div>
          <div className='row mb-3'>
            <div className='col-4 fw-600'>{t('OSS threshold')}</div>
            <div className='col'>
              {t('Exceeded on *q*').replace(
                '*q*',
                format(new Date(2022, 1, 24), 'dd.MM.yyyy')
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-4 fw-600'>{t('Registration date')}</div>
            <div className='col'>01.04.2022</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const DATA = [
  {
    Country: { id: 1, short_name: 'DE', name: 'Germany' },
    status: 'registered',
    vat_number: 'DE0000000000',
    vat_number_status: 1,
    reporting_frequency: 'quarterly',
    start_date_vat_number: '2021-08-14T00:00:00Z',
    tax_number: '0000000000',
    tax_number_status: 1,
    start_date_tax_number: '2000-01-01T00:00:00Z',
  },
  {
    Country: { id: 3, short_name: 'FR', name: 'France' },
    status: 'registered',
    vat_number: 'FR0000000000',
    vat_number_status: 1,
    reporting_frequency: 'monthly',
    start_date_vat_number: '2021-06-08T00:00:00Z',
    tax_number: '0000000000',
    tax_number_status: 1,
    start_date_tax_number: '2021-05-01T00:00:00Z',
  },
  {
    Country: { id: 8, short_name: 'CZ', name: 'Czech Republic' },
    status: 'registered',
    vat_number: 'CZ0000000000',
    vat_number_status: 1,
    reporting_frequency: 'monthly',
    start_date_vat_number: '2021-05-01T00:00:00Z',
    tax_number: '0000000000',
    tax_number_status: 1,
    start_date_tax_number: '2021-05-01T00:00:00Z',
  },
];
